var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "max-width": "600px",
        "content-class": "configuration-dialog",
        fullscreen: _vm.$vuetify.breakpoint.smAndDown,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "info",
                    attrs: { disabled: _vm.selectionCounter == 0 },
                  },
                  on
                ),
                [
                  _c("v-icon", { staticClass: "mr-2" }, [
                    _vm._v("add_location_alt"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v("Auto-Assign.."),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        attrs: {
          title: "Auto-Assign",
          shouldClose: !_vm.submitOptions.isTestRun,
        },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      }),
      _vm._v(" "),
      _vm._v(" "),
      _vm.dialog
        ? [
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { attrs: { flat: "", dark: "" } },
                  [
                    _c(
                      "v-toolbar",
                      { attrs: { dark: "", color: "primary" } },
                      [
                        _c("v-toolbar-title", [
                          _vm._v("Auto-Assign Data Sources"),
                        ]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", dark: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              { staticStyle: { overflow: "auto" } },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-alert",
                      {
                        staticClass: "ma-0 pa-2",
                        attrs: {
                          color: "warning",
                          icon: "warning",
                          outline: "",
                          value: _vm.hasMonitoringFeature,
                        },
                      },
                      [
                        _c("div", { staticClass: "primary--text" }, [
                          _vm._v(
                            "One or more of the selected Data Sources are already assigned to a location and\n            will not be affected."
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      { staticClass: "py-3" },
                      [
                        _c("p", [
                          _vm._v("\n            The "),
                          _c("strong", [_vm._v(_vm._s(_vm.selectionCounter))]),
                          _vm._v(
                            " selected data sources will be assigned to locations that match\n            their primary name or\n            one of their assigned aliases.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [_vm._v("Note:")]),
                          _vm._v(
                            " Only data sources that have not yet been assigned are affected.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "If a location does not match these names, you may choose to create new locations based on the primary\n            names."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          staticClass: "mt-0",
                          attrs: {
                            color: "info",
                            label: "Create new locations",
                            "persistent-hint": "",
                            hint: "If a matching location is not found, create a new location based on the primary name of the data source",
                          },
                          model: {
                            value: _vm.submitOptions.createNewLocations,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.submitOptions,
                                "createNewLocations",
                                $$v
                              )
                            },
                            expression: "submitOptions.createNewLocations",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          staticClass: "mt-0",
                          attrs: {
                            color: "error",
                            label: "Test run",
                            "persistent-hint": "",
                            hint: "Shows the outcome, but changes are not saved",
                          },
                          model: {
                            value: _vm.submitOptions.isTestRun,
                            callback: function ($$v) {
                              _vm.$set(_vm.submitOptions, "isTestRun", $$v)
                            },
                            expression: "submitOptions.isTestRun",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-flex",
              [
                _c(
                  "v-card",
                  { staticStyle: { "border-top": "1px solid #dddddd" } },
                  [
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              loading: _vm.loading.submit,
                              color: "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.submit()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("add_location_alt"),
                            ]),
                            _vm._v("Auto-Assign\n          "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "secondary", outline: "" },
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v("Close")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }